module.exports = __webpack_public_path__ + "img/motorsport-dark.92b32a78.svg";